// extracted by mini-css-extract-plugin
export default {"point":"classes_point__yThbW","labelWrapper":"classes_labelWrapper__D2CJF","label":"classes_label__BZrTB","tail":"classes_tail__Q0u-a"};